<template>
  <div class="login-container">
    <div class="login-bg"></div>
    <div class="login-box">
      <div class="login-logo">
        <img src="@/assets/images/logo.png" />
        <span>交底书评估工作台</span>
      </div>
      <div class="login-inner">
        <el-button link @click="handleChangeLogin">{{ isLogin ? '还没有账号？立即注册' : '返回登录' }}</el-button>
        <!-- 登录表单 -->
        <el-form v-if="isLogin" :model="loginForm" :rules="loginRules" ref="loginFormRef">
          <el-form-item prop="username" label="用户名">
            <el-input 
              v-model="loginForm.username"
              placeholder="请输入你的用户名"
              @keyup.enter="handleLogin"
            />
          </el-form-item>
          <div class="password-wrapper">
            <el-form-item prop="password" label="密码">
              <el-input 
                v-model="loginForm.password"
                type="password"
                placeholder="请输入登录密码"
                show-password
                @keyup.enter="handleLogin"
              />
            </el-form-item>
          </div>
          <el-form-item>
            <el-button 
              type="primary" 
              size="large"
              :loading="loading"
              @click="handleLogin" 
              style="width: 100%;"
              class="login-button"
            >
              登录
            </el-button>
          </el-form-item>
          <div class="form-footer">
            <!-- <el-form-item class="checkbox-wrapper">
              <el-checkbox v-model="autoLogin">自动登录</el-checkbox>
            </el-form-item> -->
            <a href="#" class="forgot-password">忘记密码</a>
          </div>
          <div class="read-wrapper">
            <div>登录即表示同意</div>
            <a>《服务协议》</a>和<a>《隐私协议》</a>
          </div>
        </el-form>
        <!-- 注册表单 -->
        <el-form v-else :model="registerForm" :rules="registerRules" ref="registerFormRef">
          <el-form-item prop="username" label="用户名">
            <el-input 
              v-model="registerForm.username"
              placeholder="请输入用户名"
              :prefix-icon="User"
            />
          </el-form-item>
          <el-form-item prop="realname" label="昵称">
            <el-input 
              v-model="registerForm.realname"
              placeholder="请输入昵称"
              :prefix-icon="User"
            />
          </el-form-item>
          <el-form-item prop="password" label="密码">
            <el-input 
              v-model="registerForm.password"
              type="password"
              placeholder="请输入密码"
              :prefix-icon="Lock"
              show-password
            />
          </el-form-item>
          <el-form-item prop="confirmPassword" label="确认密码">
            <el-input 
              v-model="registerForm.confirmPassword"
              type="password"
              placeholder="请再次输入密码"
              :prefix-icon="Lock"
              show-password
            />
          </el-form-item>
          <el-form-item>
            <el-button 
              type="primary" 
              size="large"
              :loading="registerLoading"
              @click="handleRegister" 
              style="width: 100%;"
              class="login-button"
            >
              注册
            </el-button>
          </el-form-item>
          <div class="read-wrapper">
            <div>登录即表示同意</div>
            <a>《服务协议》</a>和<a>《隐私协议》</a>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { loginApi, registerApi } from '@/api/login'
import { useUserStore } from '@/store/modules/user';
import encrypt from '@/utils/encrypt'

const userStore = useUserStore()
const router = useRouter()
const loginFormRef = ref(null)
const registerFormRef = ref(null)
const isLogin = ref(true)

// 登录表单相关
const loginForm = reactive({
  username: '',
  password: ''
})

const loginRules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' }
  ],
}

// 注册表单相关
const registerForm = reactive({
  username: '',
  realname: '',
  password: '',
  confirmPassword: ''
})

const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else {
    if (registerForm.confirmPassword !== '') {
      registerFormRef.value.validateField('confirmPassword')
    }
    callback()
  }
}

const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请再次输入密码'))
  } else if (value !== registerForm.password) {
    callback(new Error('两次输入密码不一致!'))
  } else {
    callback()
  }
}

const registerRules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
  ],
  realname: [
    { required: true, message: '请输入昵称', trigger: 'blur' },
    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, validator: validatePass, trigger: 'blur' },
    {
      pattern: /^.{6,}$/,
      message: '密码由6位符号组成!',
      trigger: 'blur'
    },
  ],
  confirmPassword: [
    { required: true, validator: validatePass2, trigger: 'blur' }
  ]
}

const autoLogin = ref(false)
const readed = ref(true)
const registerReaded = ref(true)
const loading = ref(false)
const registerLoading = ref(false)

const handleChangeLogin = () => {
  isLogin.value = !isLogin.value
  loginFormRef.value?.resetFields()
  registerFormRef.value?.resetFields()
}

const handleLogin = () => {
  if (!readed.value) {
    ElMessage.warning('请阅读并同意服务协议和隐私协议')
    return
  }
  
  loginFormRef.value.validate((valid) => {
    if (valid) {
      loading.value = true
      loginApi({ username: loginForm.username, password:encrypt(loginForm.password) }).then(res => {
        if (res) {
          const redirect = router.currentRoute.value.query.redirect
          userStore.setToken(res.token)
          ElMessage.success('登录成功')
          // 跳转到IPT页面
          setTimeout(() => {
            router.push(redirect ? decodeURIComponent(redirect) : '/home')
          })
        }
        loading.value = false
      })
    }
  })
}

const handleRegister = () => {
  if (!registerReaded.value) {
    ElMessage.warning('请阅读并同意服务协议和隐私协议')
    return
  }
  
  registerFormRef.value.validate((valid) => {
    if (valid) {
      registerLoading.value = true
      registerApi({
        username: registerForm.username,
        realname: registerForm.realname,
        password: encrypt(registerForm.password),
        roleCode: 'xinzhishu_normal'
      }).then(res => {
        if (res) {
          ElMessage.success('注册成功')
          isLogin.value = true
        }
        registerLoading.value = false
      })
    }
  })
}
</script>

<style scoped lang="scss">
$border-color: #C6C6C6;

.login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  background-color: #fff;
}
.login-bg {
  width: 40%;
  height: 100%;
  background-image: url('@/assets/images/login.png');
  background-size: cover;
}
.login-box {
  position: relative;
  width: 440px;
  margin: 0 auto;
  font-weight: 500;
  box-sizing: border-box;
  .login-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin: 0 auto 64px;
    font-size: 26px;
    img {
      width: 34px;
      height: 30px;
    }
  }
  .login-inner {
    .login-button {
      margin-top: 10px;
      background: var(--custom-sub-color);
      border-color: var(--custom-sub-color);
    }
  }
  :deep(.el-form) {
    margin: 0 auto;
    padding: 36px 0 8px;
    .el-form-item {
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 22px;
    }
    .el-form-item__error {
      font-size: 12px;
    }
    .el-form-item__label {
      justify-content: flex-end;
      flex-direction: row-reverse;
      &::before {
        color: #000 !important;
        margin-left: 4px;
      }
    }
    .el-input__wrapper {
      padding: 3px 15px;
      background: #fff;
      box-shadow: none;
      border: 1px solid $border-color;
      border-radius: 8px;
      transition: all 0.3s ease;
    }
    .password-wrapper {
      position: relative;
    }
  }
}

:deep(.el-input__wrapper.is-focus) {
  background: white;
}

:deep(.el-input__inner) {
  height: 38px;
  font-size: 15px;
}

:deep(.el-checkbox__label) {
  margin-bottom: 0;
  color: #aaa;
  font-size: 14px;
  font-weight: 400;
}

.checkbox-wrapper {
  margin-bottom: 0 !important;
}

.form-footer {
  margin-bottom: 10px;
  display: flex;
  // justify-content: space-between;
  justify-content: flex-end;
  align-items: center;
  .forgot-password {
    transition: all 0.3s ease;
    color: #000;
    font-weight: 500;
    margin-left: auto;
    text-decoration-line: none;
  }

  .forgot-password:hover {
    color: var(--el-color-primary-light-3);  /* 悬浮时的绿色 */
  }
}

.read-wrapper {
  margin-bottom: 10px;
  text-align: center;
  color: #999;
  font-size: 14px;
  line-height: 24px;
  a {
    color: #000;
  }
}
</style> 
